/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import $t from 'i18n'
import Card from 'components/common/Card'
import Page from 'components/common/Page'
import { useSelector, useDispatch } from 'react-redux'
import { Button } from 'antd'
import Actions from 'actions'
import loginService from 'services/loginService'
import { LAYOUT_TYPE, SUPPORT_LINK } from 'consts'
import { convertDate } from '../../../utils/generalUtils'

import './Success.css'

const Success = () => {
  const dispatch = useDispatch()
  const applicationId = useSelector(state => state.application?.applicationId)
  const deeplinkForSignup = useSelector(
    state => state.application?.deeplinkForSignup
  )
  const paymentLink = useSelector(state => state.application?.paymentLink)
  const locale = useSelector(state => state.locale.locale)
  const selectedPlan = useSelector(state => state.plan?.selectedPlan)
  const isBroker = useSelector(state => state.app.layout === LAYOUT_TYPE.broker)
  const paymentEnabled = useSelector(
    state => state.app.appConfig?.payment_enabled
  )
  const memberQualifyLifeEvent = useSelector(
    state => state.member?.memberQualifyLifeEvent
  )
  // this application id will be stored once
  // and cleared from the store once loaded in the use effect
  const [applicationIdToDisplay, setApplicationIdToDisplay] = useState()
  const [deeplinkForCreateAccount, setDeeplinkForCreateAccount] =
    useState(deeplinkForSignup)
  const [paymentLinkToPay, setPaymentLinkToPay] = useState(paymentLink)

  // the title is what before the ()
  const planNameSplit = selectedPlan?.translated_name?.split('(')
  const selectedPlanTitle = planNameSplit?.[0]
  // the description is what is inside the ()
  const selectedPlanDescription = planNameSplit?.[1]
    ?.replaceAll('(', '')
    .replaceAll(')', '')

  // if the deeplink is not available, then the user will need to see conflic data/description
  const isConflictExist = !deeplinkForCreateAccount

  useEffect(() => {
    // we clearing the application id becuse it cannot we updated any more
    // the user will be navigated to home page if reloaded
    setApplicationIdToDisplay(applicationId)
    dispatch(Actions.createAction(Actions.APPLICATION_ID_REMOVED))

    const token = loginService.getToken()
    // set the deeplink before clearing the token (if exists)
    if (deeplinkForSignup) {
      setDeeplinkForCreateAccount(
        deeplinkForSignup + `&locale=${locale}&token=${token}`
      )
    }
    if (paymentLink) {
      setPaymentLinkToPay(paymentLink + `&locale=${locale}&token=${token}`)
    }
    loginService.clearTokens()
  }, [])

  return (
    <Page
      className='enroll-success'
      title={isConflictExist ? $t('common.note') : $t('enroll.success.title')}
      image={isConflictExist ? 'support.svg' : 'antidote_welcome.svg'}
      canNavigateBack={false}
    >
      <Card className='success-card'>
        <div className='detail-field semi-bold'>
          {$t('enroll.success.applicationId')}: {applicationIdToDisplay}
        </div>
        {!isConflictExist && (
          <>
            <div className='detail-field'>
              <span className='semi-bold'>{selectedPlanTitle}</span>
              {selectedPlanDescription}
            </div>
            <div className='detail-field semi-bold'>
              {$t('enroll.success.effectiveDate', {
                date: convertDate(memberQualifyLifeEvent?.coverageStartDate)
              })}
              <div className='semi-bold'>
                {!paymentEnabled && $t('enroll.success.notice')}
              </div>
            </div>
            <h2 className='semi-bold plan-price'>
              {$t('enroll.plans.plan.monthlyPremium')}: $
              {selectedPlan?.plan_rate_multiplied}
            </h2>
          </>
        )}
        {isConflictExist && (
          <div className='semi-bold support-text'>
            {$t('enroll.success.support')}
          </div>
        )}
        <div className='success-footer'>
          {isConflictExist && (
            <Button
              className='trackable contact-support-btn'
              data-name='contact-support-btn'
              type='primary'
              onClick={() => window.open(SUPPORT_LINK)}
            >
              {$t('dialogs.systemError.contactUs')}
            </Button>
          )}
          {!isConflictExist && (
            <>
              {paymentEnabled && (
                <Button
                  className='trackable'
                  data-name={isBroker ? 'pay-now-btn-broker' : 'pay-now-btn'}
                  type='primary'
                  onClick={() => window.open(paymentLinkToPay, '_self')}
                >
                  {$t('enroll.success.payNow')}
                </Button>
              )}
              {!isBroker && (
                <Button
                  className='trackable set-up-account-btn'
                  data-name='set-up-account-btn'
                  type={paymentEnabled ? 'outline' : 'primary'}
                  onClick={() => window.open(deeplinkForCreateAccount, '_self')}
                >
                  {$t('enroll.success.setUpAccount')}
                </Button>
              )}
            </>
          )}
        </div>
      </Card>
    </Page>
  )
}

export default Success
